import styled from 'styled-components';

import Label from '@rover/components/src/typography/Label';

const FilterLabel = styled(Label)`
  display: block;
  margin-bottom: ${({ mb, theme }) => mb || theme.space['2x']};
  width: 100%;
  font-weight: 700;
  color: ${({ theme, color }) => (color ? theme.textColor[color] : theme.textColor.secondary)};
`;

export default FilterLabel;
